export const BLOG_POSTS = [
  {
    slug: "what-is-ai-digital-worker-guide-2026",
    title: "What is an AI Digital Worker? The Complete Guide for 2026",
    excerpt: "AI digital workers are transforming how businesses operate. Learn what they are, how they differ from chatbots, and how to deploy your first one.",
    date: "2026-06-01",
    readTime: "7 min read",
    tag: "Fundamentals",
    category: "AI Agents",
    tags: ["AI Agents", "Digital Workers", "Automation", "Business"],
    ogImage: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1200&h=630&fit=crop",
    author: {
      name: "Max Employee Team",
      role: "AI Research & Product",
      bio: "The Max Employee team builds autonomous AI digital workers for businesses worldwide. Our research focuses on practical AI deployment, ROI measurement, and scaling automation.",
      avatar: "https://ui-avatars.com/api/?name=Max+Employee+Team&background=F59E0B&color=09090B&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "automate-customer-support-ai-agents",
    title: "How to Automate Customer Support with AI Agents",
    excerpt: "A step-by-step guide to automating your customer support with AI agents — from setup to measuring success with real metrics.",
    date: "2026-06-02",
    readTime: "6 min read",
    tag: "How-To",
    category: "Tutorials",
    tags: ["Customer Support", "AI Agents", "Automation", "How-To", "Metrics"],
    ogImage: "https://images.unsplash.com/photo-1531746790731-6c087fecd65a?w=1200&h=630&fit=crop",
    author: {
      name: "Max Employee Team",
      role: "Customer Success",
      bio: "Our customer success team has helped over 30 businesses deploy AI agents for support automation, reducing response times by an average of 60%.",
      avatar: "https://ui-avatars.com/api/?name=Max+Employee+Team&background=F59E0B&color=09090B&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "max-os-cloud-vs-zapier-comparison",
    title: "Max OS Cloud vs Zapier: Which is Right for Your Business?",
    excerpt: "An honest comparison of Max OS Cloud and Zapier — capabilities, pricing, and which one fits your automation needs.",
    date: "2026-06-03",
    readTime: "5 min read",
    tag: "Comparison",
    category: "Integrations",
    tags: ["Max OS Cloud", "Zapier", "Automation", "Comparison", "Integrations"],
    ogImage: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&h=630&fit=crop",
    author: {
      name: "Max Employee Team",
      role: "Product Strategy",
      bio: "Our product team has deep expertise in automation platforms, having evaluated and built tools across the automation landscape.",
      avatar: "https://ui-avatars.com/api/?name=Max+Employee+Team&background=F59E0B&color=09090B&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "ecommerce-ai-agents-scale",
    title: "5 Ways E-commerce Businesses Use AI Agents to Scale",
    excerpt: "From support to abandoned cart recovery — real e-commerce use cases where AI agents drive measurable results.",
    date: "2026-06-04",
    readTime: "6 min read",
    tag: "E-commerce",
    category: "Case Studies",
    tags: ["E-commerce", "AI Agents", "Scaling", "Use Cases", "Automation"],
    ogImage: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1200&h=630&fit=crop",
    author: {
      name: "Max Employee Team",
      role: "E-commerce Solutions",
      bio: "Our e-commerce team works with online retailers to deploy AI agents that handle support, sales, and operations — driving measurable revenue growth.",
      avatar: "https://ui-avatars.com/api/?name=Max+Employee+Team&background=F59E0B&color=09090B&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "roi-ai-agents-real-numbers",
    title: "The ROI of AI Agents: Real Numbers from Real Businesses",
    excerpt: "Hours saved, response time reduction, cost savings — the real metrics behind AI agent ROI with calculation frameworks.",
    date: "2026-06-05",
    readTime: "5 min read",
    tag: "ROI",
    category: "Case Studies",
    tags: ["ROI", "Metrics", "Business Intelligence", "Cost Savings", "AI Agents"],
    ogImage: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=630&fit=crop",
    author: {
      name: "Max Employee Team",
      role: "Business Intelligence",
      bio: "Our team analyzes performance data across all Max OS Cloud deployments to measure and optimize ROI for every customer.",

      avatar: "https://ui-avatars.com/api/?name=Max+Employee+Team&background=F59E0B&color=09090B&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "ai-agents-real-estate-automation",
    title: "AI Agents in Real Estate: Automating Property Management and Lead Qualification",
    excerpt: "How real estate agencies are using AI agents to qualify leads, schedule viewings, and manage property listings 24/7.",
    date: "2026-06-06",
    readTime: "6 min read",
    tag: "Real Estate",
    category: "Case Studies",
    tags: ["Real Estate", "AI Agents", "Lead Qualification", "Property Management", "Automation"],
    ogImage: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=630&fit=crop",
    author: {
      name: "Sarah Chen",
      role: "Real Estate Solutions Lead",
      bio: "Sarah has 12 years of experience in real estate technology and has helped over 50 agencies deploy AI-powered solutions for lead management and property operations.",

      avatar: "https://ui-avatars.com/api/?name=Sarah+Chen&background=7C3AED&color=ffffff&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "multi-agent-workflows-guide",
    title: "Multi-Agent Workflows: How to Orchestrate AI Teams for Complex Business Tasks",
    excerpt: "Learn how to design and deploy multi-agent systems where specialized AI workers collaborate to handle end-to-end business processes.",
    date: "2026-06-07",
    readTime: "8 min read",
    tag: "Advanced",
    category: "AI Agents",
    tags: ["Multi-Agent", "Workflows", "Orchestration", "AI Teams", "Advanced"],
    ogImage: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&h=630&fit=crop",
    author: {
      name: "Alex Rivera",
      role: "AI Architecture Lead",
      bio: "Alex designs multi-agent systems for enterprise clients, specializing in workflow orchestration and agent communication protocols.",

      avatar: "https://ui-avatars.com/api/?name=Alex+Rivera&background=2563EB&color=ffffff&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "ai-agent-security-compliance",
    title: "AI Agent Security and Compliance: What Businesses Need to Know",
    excerpt: "Data privacy, access control, audit trails — a comprehensive guide to keeping your AI agents secure and compliant.",
    date: "2026-06-08",
    readTime: "7 min read",
    tag: "Security",
    category: "Industry News",
    tags: ["Security", "Compliance", "Data Privacy", "AI Agents", "Enterprise"],
    ogImage: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=1200&h=630&fit=crop",
    author: {
      name: "Marcus Johnson",
      role: "Security & Compliance Officer",
      bio: "Marcus oversees security architecture for AI deployments, with expertise in GDPR, SOC 2, and enterprise compliance frameworks.",

      avatar: "https://ui-avatars.com/api/?name=Marcus+Johnson&background=DC2626&color=ffffff&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "whatsapp-ai-agent-setup",
    title: "How to Set Up an AI Agent on WhatsApp: Complete Step-by-Step Guide",
    excerpt: "From WhatsApp Business API to going live — everything you need to deploy an AI agent on WhatsApp in under 30 minutes.",
    date: "2026-06-09",
    readTime: "6 min read",
    tag: "WhatsApp",
    category: "Tutorials",
    tags: ["WhatsApp", "Setup", "Tutorial", "AI Agents", "Messaging"],
    ogImage: "https://images.unsplash.com/photo-1611746872915-64382b5c76da?w=1200&h=630&fit=crop",
    author: {
      name: "Priya Patel",
      role: "Integration Specialist",
      bio: "Priya specializes in messaging platform integrations and has helped hundreds of businesses deploy AI agents on WhatsApp, Telegram, and other messaging channels.",

      avatar: "https://ui-avatars.com/api/?name=Priya+Patel&background=059669&color=ffffff&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "ai-agents-marketing-agencies",
    title: "How Marketing Agencies Use AI Agents to Scale Client Services",
    excerpt: "From content creation to campaign management — how agencies are using AI agents to serve more clients without adding headcount.",
    date: "2026-06-10",
    readTime: "6 min read",
    tag: "Marketing",
    category: "Case Studies",
    tags: ["Marketing", "Agencies", "AI Agents", "Scaling", "Client Services"],
    ogImage: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&h=630&fit=crop",
    author: {
      name: "Emma Larsson",
      role: "Marketing Solutions Director",
      bio: "Emma works with marketing agencies to implement AI solutions that scale client services while maintaining quality and brand consistency.",

      avatar: "https://ui-avatars.com/api/?name=Emma+Larsson&background=D97706&color=ffffff&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "ai-agent-integrations-ecosystem",
    title: "The AI Agent Integration Ecosystem: Connecting Your Tools for Maximum Automation",
    excerpt: "A deep dive into the integration landscape — CRMs, helpdesks, calendars, and how to connect everything to your AI agents.",
    date: "2026-06-11",
    readTime: "7 min read",
    tag: "Integrations",
    category: "Integrations",
    tags: ["Integrations", "CRM", "API", "Automation", "Ecosystem"],
    ogImage: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1200&h=630&fit=crop",
    author: {
      name: "David Kim",
      role: "Integration Architect",
      bio: "David designs integration frameworks for AI agent platforms, with expertise in CRM, helpdesk, and productivity tool APIs.",

      avatar: "https://ui-avatars.com/api/?name=David+Kim&background=7C3AED&color=ffffff&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "ai-agents-2026-trends",
    title: "AI Agent Trends 2026: What's Shaping the Future of Autonomous Workers",
    excerpt: "Multi-agent systems, voice AI, edge deployment, and more — the trends defining the next generation of AI agents.",
    date: "2026-06-12",
    readTime: "5 min read",
    tag: "Trends",
    category: "Industry News",
    tags: ["Trends", "2026", "AI Agents", "Future", "Innovation"],
    ogImage: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=1200&h=630&fit=crop",
    author: {
      name: "Dr. Lisa Wang",
      role: "AI Research Director",
      bio: "Dr. Wang leads AI research at Max Employee, focusing on emerging trends in autonomous agents, multi-agent systems, and human-AI collaboration.",

      avatar: "https://ui-avatars.com/api/?name=Lisa+Wang&background=DB2777&color=ffffff&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "customer-support-metrics-ai",
    title: "Customer Support Metrics That Matter: Measuring AI Agent Performance",
    excerpt: "First response time, resolution rate, CSAT, and more — the KPIs you need to track to optimize your AI support agents.",
    date: "2026-06-13",
    readTime: "5 min read",
    tag: "Metrics",
    category: "Tutorials",
    tags: ["Metrics", "Customer Support", "KPIs", "Performance", "Analytics"],
    ogImage: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&h=630&fit=crop",
    author: {
      name: "Tom Bradley",
      role: "Analytics Lead",
      bio: "Tom specializes in support analytics and has developed measurement frameworks used by hundreds of businesses to optimize their AI agent performance.",

      avatar: "https://ui-avatars.com/api/?name=Tom+Bradley&background=0891B2&color=ffffff&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "ai-agents-consulting-business",
    title: "Building a Consulting Business with AI Agents: A Practitioner's Guide",
    excerpt: "How consultants are using AI agents to deliver better client outcomes, scale their practice, and increase billable hours.",
    date: "2026-06-14",
    readTime: "6 min read",
    tag: "Consulting",
    category: "Case Studies",
    tags: ["Consulting", "AI Agents", "Business Growth", "Client Services", "Automation"],
    ogImage: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&h=630&fit=crop",
    author: {
      name: "Rachel Green",
      role: "Consulting Solutions Lead",
      bio: "Rachel helps consulting firms implement AI solutions that enhance client delivery while scaling operational capacity.",

      avatar: "https://ui-avatars.com/api/?name=Rachel+Green&background=65A30D&color=ffffff&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "ai-agent-failures-lessons",
    title: "AI Agent Failures: Lessons Learned from Real Deployments",
    excerpt: "What goes wrong when AI agents are deployed incorrectly — and how to avoid the most common pitfalls.",
    date: "2026-06-15",
    readTime: "7 min read",
    tag: "Lessons",
    category: "Industry News",
    tags: ["Failures", "Lessons Learned", "Best Practices", "AI Agents", "Deployment"],
    ogImage: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=1200&h=630&fit=crop",
    author: {
      name: "James Mitchell",
 role: "Operations Director",
      bio: "James has overseen 100+ AI agent deployments and specializes in identifying and resolving common failure patterns.",

      avatar: "https://ui-avatars.com/api/?name=James+Mitchell&background=4338CA&color=ffffff&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "how-to-choose-right-ai-agent-for-your-industry",
    title: "How to Choose the Right AI Agent for Your Industry",
    excerpt: "Not every AI agent fits every industry. This decision framework helps you match agent capabilities to your specific business needs, budget, and technical maturity.",
    date: "2026-06-05",
    readTime: "8 min read",
    tag: "Decision Guide",
    category: "AI Agents",
    tags: ["AI Agents", "Decision Guide", "Industry", "Automation", "Strategy"],
    ogImage: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=1200&h=630&fit=crop",
    author: {
      name: "Max Employee Team",
      role: "AI Research & Product",
      bio: "The Max Employee team builds autonomous AI digital workers for businesses worldwide. Our research focuses on practical AI deployment, ROI measurement, and scaling automation.",
      avatar: "https://ui-avatars.com/api/?name=Max+Employee+Team&background=F59E0B&color=09090B&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "ai-agent-roi-calculator-how-much-can-you-save",
    title: "AI Agent ROI Calculator: How Much Can You Actually Save?",
    excerpt: "A practical framework for calculating the real ROI of AI agent deployment — with actual numbers, formulas, and industry benchmarks you can apply today.",
    date: "2026-06-05",
    readTime: "7 min read",
    tag: "ROI",
    category: "Business",
    tags: ["ROI", "Business", "Automation", "Metrics", "Cost Savings"],
    ogImage: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1200&h=630&fit=crop",
    author: {
      name: "Max Employee Team",
      role: "AI Research & Product",
      bio: "The Max Employee team builds autonomous AI digital workers for businesses worldwide. Our research focuses on practical AI deployment, ROI measurement, and scaling automation.",
      avatar: "https://ui-avatars.com/api/?name=Max+Employee+Team&background=F59E0B&color=09090B&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "complete-guide-multi-agent-workflows-2026",
    title: "The Complete Guide to Multi-Agent Workflows in 2026",
    excerpt: "Learn how to design, deploy, and manage multi-agent workflows where specialized AI agents collaborate to handle complex business processes end-to-end.",
    date: "2026-06-05",
    readTime: "9 min read",
    tag: "Advanced",
    category: "AI Agents",
    tags: ["AI Agents", "Multi-Agent", "Workflows", "Advanced", "Automation"],
    ogImage: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1200&h=630&fit=crop",
    author: {
      name: "Max Employee Team",
      role: "AI Research & Product",
      bio: "The Max Employee team builds autonomous AI digital workers for businesses worldwide. Our research focuses on practical AI deployment, ROI measurement, and scaling automation.",
      avatar: "https://ui-avatars.com/api/?name=Max+Employee+Team&background=F59E0B&color=09090B&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "whatsapp-ai-agents-definitive-setup-guide",
    title: "WhatsApp AI Agents: The Definitive Setup Guide",
    excerpt: "Everything you need to know to set up an AI agent on WhatsApp — from Business API configuration to conversation design, compliance, and scaling.",
    date: "2026-06-05",
    readTime: "8 min read",
    tag: "Tutorial",
    category: "Tutorials",
    tags: ["WhatsApp", "AI Agents", "Tutorial", "Setup", "Messaging"],
    ogImage: "https://images.unsplash.com/photo-1611605698335-8b1569810432?w=1200&h=630&fit=crop",
    author: {
      name: "Max Employee Team",
      role: "Customer Success",
      bio: "Our customer success team has helped over 30 businesses deploy AI agents for support automation, reducing response times by an average of 60%.",
      avatar: "https://ui-avatars.com/api/?name=Max+Employee+Team&background=F59E0B&color=09090B&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "ai-agents-vs-human-employees-when-to-use-each",
    title: "AI Agents vs Human Employees: When to Use Each",
    excerpt: "An honest comparison of AI agents and human employees — where each excels, where each fails, and how to build a hybrid team that leverages the best of both.",
    date: "2026-06-05",
    readTime: "7 min read",
    tag: "Comparison",
    category: "Business",
    tags: ["AI Agents", "Human Employees", "Comparison", "Strategy", "Team"],
    ogImage: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&h=630&fit=crop",
    author: {
      name: "Max Employee Team",
      role: "AI Research & Product",
      bio: "The Max Employee team builds autonomous AI digital workers for businesses worldwide. Our research focuses on practical AI deployment, ROI measurement, and scaling automation.",
      avatar: "https://ui-avatars.com/api/?name=Max+Employee+Team&background=F59E0B&color=09090B&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "build-your-first-ai-agent-in-30-minutes",
    title: "How to Build Your First AI Agent in 30 Minutes",
    excerpt: "A hands-on tutorial that walks you through building a fully functional AI agent from scratch — no coding experience required. By the end, you'll have a working agent you can deploy today.",
    date: "2026-06-16",
    readTime: "8 min read",
    tag: "Tutorial",
    category: "Tutorials",
    tags: ["AI Agents", "Tutorial", "Beginner", "Hands-On", "Quick Start"],
    ogImage: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=1200&h=630&fit=crop",
    author: {
      name: "Max Employee Team",
      role: "AI Research & Product",
      bio: "The Max Employee team builds autonomous AI digital workers for businesses worldwide. Our research focuses on practical AI deployment, ROI measurement, and scaling automation.",
      avatar: "https://ui-avatars.com/api/?name=Max+Employee+Team&background=F59E0B&color=09090B&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "state-of-ai-agents-2026-whats-changed",
    title: "The State of AI Agents in 2026: What's Changed",
    excerpt: "A comprehensive analysis of how AI agents have evolved in 2026 — from experimental toys to essential business infrastructure. What's changed, what's next, and what it means for your business.",
    date: "2026-06-17",
    readTime: "9 min read",
    tag: "Analysis",
    category: "Industry News",
    tags: ["AI Agents", "2026", "Industry Analysis", "Trends", "Business"],
    ogImage: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=1200&h=630&fit=crop",
    author: {
      name: "Max Employee Team",
      role: "AI Research & Product",
      bio: "The Max Employee team builds autonomous AI digital workers for businesses worldwide. Our research focuses on practical AI deployment, ROI measurement, and scaling automation.",
      avatar: "https://ui-avatars.com/api/?name=Max+Employee+Team&background=F59E0B&color=09090B&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
  {
    slug: "case-study-company-saved-40-hours-per-week-ai-agents",
    title: "Case Study: How TechFlow Solutions Saved 40 Hours/Week with AI Agents",
    excerpt: "How a 25-person SaaS company deployed AI agents to handle customer support and internal operations — saving 40 hours per week and improving customer satisfaction by 35%.",
    date: "2026-06-18",
    readTime: "7 min read",
    tag: "Case Study",
    category: "Case Studies",
    tags: ["Case Study", "AI Agents", "SaaS", "Customer Support", "ROI"],
    ogImage: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=630&fit=crop",
    author: {
      name: "Max Employee Team",
      role: "Customer Success",
      bio: "Our customer success team has helped over 30 businesses deploy AI agents for support automation, reducing response times by an average of 60%.",
      avatar: "https://ui-avatars.com/api/?name=Max+Employee+Team&background=F59E0B&color=09090B&size=128&bold=true",
      social: {
        twitter: "https://twitter.com/maxemployee",
        linkedin: "https://linkedin.com/company/maxemployee",
      },
    },
    content: null,
  },
];

export function getPostBySlug(slug) {
  return BLOG_POSTS.find((post) => post.slug === slug);
}

export function getRecentPosts(count = 3) {
  return BLOG_POSTS.slice(0, count);
}

export function getRelatedPosts(slug, count = 3) {
  const current = BLOG_POSTS.find((post) => post.slug === slug);
  if (!current) return BLOG_POSTS.slice(0, count);
  const sameCategory = BLOG_POSTS.filter(
    (post) => post.slug !== slug && post.category === current.category
  );
  if (sameCategory.length >= count) return sameCategory.slice(0, count);
  const others = BLOG_POSTS.filter(
    (post) => post.slug !== slug && post.category !== current.category
  );
  return [...sameCategory, ...others].slice(0, count);
}

export function getAuthorByName(name) {
  const post = BLOG_POSTS.find(
    (p) => p.author && p.author.name.toLowerCase() === name.toLowerCase()
  );
  return post ? post.author : null;
}

export function getPostsByAuthor(authorName) {
  return BLOG_POSTS.filter(
    (p) => p.author && p.author.name.toLowerCase() === authorName.toLowerCase()
  );
}

export function getAllAuthors() {
  const authorMap = new Map();
  BLOG_POSTS.forEach((p) => {
    if (p.author && p.author.name) {
      const key = p.author.name.toLowerCase();
      if (!authorMap.has(key)) {
        authorMap.set(key, {
          ...p.author,
          postCount: 1,
          posts: [p],
        });
      } else {
        const entry = authorMap.get(key);
        entry.postCount++;
        entry.posts.push(p);
      }
    }
  });
  return Array.from(authorMap.values());
}
